<template>
  <div class="invalid-special-rate">
    <i class="icon-alert md color-primary"></i>
    <div class="invalid-special-rate__message">
      <span class="invalid-special-rate__title">{{
        translate('rdPreselectedFilterNotMatchesTitle')
      }}</span>
      <span class="invalid-special-rate__description">{{
        translate('rdPreselectedFilterNotMatchesDescription')
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreselectedFilterNotMatches'
}
</script>

<style lang="scss" scoped>
.invalid-special-rate {
  display: flex;
  padding: 2.5rem;
  background-color: #fcf0f1;

  &__message {
    display: flex;
    flex-direction: column;
    padding-left: 2rem;
  }

  &__title {
    font-weight: bold;
    font-size: 14px;
  }

  &__description {
    font-size: 12px;
  }
}
</style>
